import { Button } from '@/components/ui'

interface EmptyChatStateProps {
  onCreate: () => void | Promise<void>
  createFailed?: boolean
}

export default function EmptyChatState({
  onCreate,
  createFailed = false,
}: EmptyChatStateProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6">
      <div className="text-center">
        <p className="text-base font-medium">No active conversation</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Start a new chat to ask about transactions in this project.
        </p>
      </div>
      <Button onClick={() => onCreate()}>Start a new chat</Button>
      {createFailed && (
        <p className="text-sm text-destructive">
          Couldn't start the chat. Please try again.
        </p>
      )}
    </div>
  )
}
